<script lang="ts">
	import { nbspify } from "../../../../core/utils/nbspify";
	import type { WeddingCardProps } from "../../templates/WeddingsProps";
	import StaticPicture from "../Picture/StaticPicture.svelte";

	let cardClass = "";
	export { cardClass as class };
	export let weddingCard: WeddingCardProps;
</script>

<div class="border-secondary-200 h-fit rounded-2xl border p-4 sm:p-6 {cardClass}">
	<div class="flex gap-1 sm:gap-3">
		{#if weddingCard.images.length > 1}
			{#each weddingCard.images as image}
				<StaticPicture
					class="h-full w-full overflow-hidden rounded-md"
					{image}
					alt={weddingCard.alt}
					height={196}
					width={157}
					loading="lazy"
				/>
			{/each}
		{/if}
	</div>
	{#if weddingCard.images.length === 1}
		<StaticPicture
			class="aspect-square h-auto w-full overflow-hidden rounded-md"
			image={weddingCard.images[0] ?? ""}
			alt={weddingCard.alt}
			height={496}
			width={496}
			loading="lazy"
		/>
	{/if}
	<div class="mt-6">
		<p class="mb-4 text-lg font-semibold">{nbspify(weddingCard.heading)}</p>
		{#each weddingCard.descs as desc, index}
			<p class={index === weddingCard.descs.length - 1 || weddingCard.descs.length === 1 ? "mb-0" : "mb-4"}>
				{nbspify(desc)}
			</p>
		{/each}
	</div>
</div>
